
import * as moment from "moment";
// import { SurveyMonthlyReport, SurveyQuestions } from "./pages/_api-service/Interface/survey";
// import { User } from "./pages/_api-service/Interface/user";
import { CacheApp, SurveyModel, SurveyMonthlyReport, SurveyQuestions, UserModel } from "./pages/_api-service/models";

export class Utils {
  title = 'Patient Survey';


}


export function getYesNoRating(rate: number): string {
  let output = "";

  if (rate == 5) {
    output = "Yes"
  } else if (rate == 0) {
    output = "No"
  }

  return output;
}



export function getMealRatingExplanation(rate: number): string {
  let out;

  if (rate == 1) {
    out = "Very Dissatisfied";
  } else if (rate == 2) {
    out = "Dissatisfied";
  } else if (rate == 3) {
    out = "Neutral";
  } else if (rate == 4) {
    out = "Satisfied";
  } else if (rate == 5) {
    out = "Very Satisfied";
  }

  return out;
}


export function getRatingExplanation(rate: number): string {
  let out;

  if (rate == 1) {
    out = "Very Poor";
  } else if (rate == 2) {
    out = "Poor";
  } else if (rate == 3) {
    out = "Good";
  } else if (rate == 4) {
    out = "Very Good";
  } else if (rate == 5) {
    out = "Excellent";
  }

  return out;
}

export function removeLeadingNumber(text: string): string {
  return text.replace(/^\d+(\.\d+)*\.?\s*/, '').toLowerCase();
}


export const QuestionForm: SurveyQuestions[] = [
  {
    section: "1. Reception and Admission",
    questios: [
      {
        answerType: "rating",
        questionNumber: "1.1. How would you rate the friendliness and courtesy of the Reception staff",
        isPriority: false
      },
      {
        answerType: "yes/no",
        questionNumber: "1.2. Was the waiting time acceptable to you",
        isPriority: false
      },
      {
        answerType: "yes/no",
        questionNumber: "1.3. Were you satisfied with the admission process",
        isPriority: false
      }
    ]
  },
  {
    section: "2. Nursing Care",
    questios: [
      {
        answerType: "rating",
        questionNumber: "2.1. How would you rate the friendliness and courtesy of the Nursing staff",
        isPriority: false
      },
      {
        answerType: "rating",
        questionNumber: "2.2. How was the response time of the Nurses when you pressed the call button",
        isPriority: false
      },
      {
        answerType: "yes/no",
        questionNumber: "2.3. Were your medical treatment and procedures explained to you adequately",
        isPriority: false
      },
      {
        answerType: "yes/no",
        questionNumber: "2.4. When given medication, did the Nurses explain its purpose and potential side effects to you",
        isPriority: false
      }
    ]
  },
  {
    section: "3. Doctor Care",
    questios: [
      {
        answerType: "rating",
        questionNumber: "3.1. How would you rate the friendliness and courtesy of your Doctor",
        isPriority: false
      },
      {
        answerType: "rating",
        questionNumber: "3.2. How satisfied were you with the level of medical care provided by your Doctor",
        isPriority: false
      },
      {
        answerType: "yes/no",
        questionNumber: "3.3. Did your Doctor sufficiently explain your condition and treatment plan to you",
        isPriority: false
      }
    ]
  },
  {
    section: "4. Cleaning",
    questios: [
      {
        answerType: "rating",
        questionNumber: "4.1. How would you rate the friendliness and courtesy of the Cleaning staff",
        isPriority: false
      },
      {
        answerType: "rating",
        questionNumber: "4.2. How would you rate the cleanliness of the ward and bathroom facilities",
        isPriority: false
      },
      {
        answerType: "rating",
        questionNumber: "4.3. How frequently was your room and bathroom cleaned during your stay",
        isPriority: false
      }
    ]
  },
  {
    section: "5. Catering",
    questios: [
      {
        answerType: "rating",
        questionNumber: "5.1. How would you rate the friendliness and courtesy of the Catering staff",
        isPriority: false
      },
      {
        answerType: "none",
        questionNumber: "5.2. Please indicate your level of satisfaction on the following questions:",
        isPriority: false
      },
      {
        answerType: "rating",
        questionNumber: "5.2.1. Menu choice",
        isSubQuestion: true,
        isPriority: false
      },
      {
        answerType: "rating",
        questionNumber: "5.2.2. Presentation of meals",
        isSubQuestion: true,
        isPriority: false
      },
      {
        answerType: "rating",
        questionNumber: "5.2.3. Temperature of meals",
        isSubQuestion: true,
        isPriority: false
      },
      {
        answerType: "rating",
        questionNumber: "5.2.4. Taste and quality of meals",
        isSubQuestion: true,
        isPriority: false
      }
    ]
  },
  {
    section: "6. Overall Assessment",
    questios: [
      {
        answerType: "rating",
        questionNumber: "6.1. Overall, how would you rate your experience at our hospital",
        isPriority: false
      },
      {
        answerType: "yes/no",
        questionNumber: "6.2. Were the noise levels within the hospital acceptable to you during the day",
        isPriority: false
      },
      {
        answerType: "yes/no",
        questionNumber: "6.3. Were the noise levels within the hospital acceptable to you during the night?",
        isPriority: false
      },
      {
        answerType: "rating",
        questionNumber: "6.4. How would you rate the accommodation and comfort provided to your visitors",
        isPriority: false
      },
      {
        answerType: "rating",
        questionNumber: "6.5. How likely are you to recommend our hospital to your family and friends",
        isPriority: false
      }
    ]
  },
  {
    section: "7. How did you learn about us",
    questios: [
      {
        answerType: "radio",
        questionNumber: "",
        options: [
          "GP referral",
          "Specialist referral",
          "Facebook",
          "LinkedIn",
          "Twitter",
          "Search engine (e.g., Google or Bing)",
          "Family/Friend/Colleague recommendation",
        ],
        isPriority: false
      }
    ]
  },
  {
    section: "8. Would you be interested in providing feedback and potentially being invited to our Patient Advisory Committee (PAC) meetings, where we discuss improvement opportunities and action plans to enhance the overall patient experience in our hospital?",
    questios: [
      {
        answerType: "radio",
        questionNumber: "",
        options: [
          "Yes",
          "No"
        ],
        isPriority: false
      }
    ]
  }

]


export function getCategoryScore(value: string): number {
  let score = 0;

  if (value.includes("reception")) {
    score = 94;
  } else if (value.includes("nursing")) {
    score = 93;
  } else if (value.includes("doctor")) {
    score = 95;
  } else if (value.includes("cleaning")) {
    score = 88;
  } else if (value.includes("catering")) {
    score = 69;
  } else if (value.includes("assessment")) {
    score = 91;
  }

  return score;
}



export function getOverallScorePerCategory(surveylist: any[], category: string): any {
  let final_score: any = 0.0;
  let count: number = 0;
  let score_sum: number = 0;


  if (surveylist?.length) {

    surveylist.forEach(surveyArray => {
      let survey = surveyArray.survey;
      // test
      survey.forEach(questionArray => {
        let section = questionArray?.section.toLocaleLowerCase();
        // test.survey[0]

        if (section && section.includes(category)) {
          let question = questionArray.question;

          question.forEach(questionArray => {
            // test.survey[0].question[0]

            if (questionArray?.answer === "rating" ||
              questionArray?.answer === "yes/no") {

              let score_int = typeof (questionArray.score) == "string" ? parseInt(questionArray.score) : typeof (questionArray.score) === "number" ? questionArray.score : 0;
              score_sum += score_int;
              count += 1;
              // console.log(section, ": ", score_int, " ", score_sum, "%")

            }

          })

        }

      })
    })

    let max_score = count * 5;
    let score_avg = score_sum / max_score;
    final_score = score_avg * 100;
  }

  return isNaN(parseFloat((final_score).toFixed(2))) ? 0 : parseFloat((final_score).toFixed(2));
}

export const getSurveyDepartment = {
  reception: {
    name: "reception",
    caption: "Reception and Admission"
  },
  doctor: {
    name: "doctor",
    caption: "Doctor Care"
  },
  cleaning: {
    name: "cleaning",
    caption: "Cleaning"
  },
  catering: {
    name: "catering",
    caption: "Catering"
  },
  assessment: {
    name: "assessment",
    caption: "Overall Assessment"
  },
  nursing: {
    name: "nursing",
    caption: "Nursing Care"
  },
}


export function getUsers(category: string): UserModel[] {
  let users: UserModel[] = []

  return users;
}

export function isUserRoleAllowed(role) {
  let bool;

  if (role) {

    if (role == "Admin" || role == "Superuser") {
      bool = true;
    }

  }

  return bool;
}

export function isTestUser(id: string): boolean {
  let bool: boolean;

  if (["nic@mail.com", "support@mail.com"].includes(id)) {
    bool = true;
  }

  return bool;

}


export function isLocal(url: string = location.origin): boolean {
  let bool: boolean;
  // let link = location.origin;

  if (url.includes("localhost")) {
    bool = true;
  }

  return bool;

}

export function getRemoved_Text(value: string): string {
  let text: string = "";

  if (value) {
    text = value.replace(/_/g, " ");
  }

  return text
}

export const getAllMonths: string[] = [
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'
]


export const CACHE: CacheApp = {
  Surveys: "survey",
  Patients: "patients",
  Incidents: "incident",
  Users: "user",
  IncidentAudit: "incidentAudit",
  Grouups: "group",
}


export function getOverallScore(surveylist: SurveyModel[]): number {
  let score: any = 0.0;

  if (surveylist?.length) {
    let sum: number = 0;
    let length: number = surveylist.length;

    surveylist.forEach(survey => {

      let score_int = isNaN(parseFloat(survey.overallScore.toFixed(2))) ?
        0.0 : parseFloat(survey.overallScore.toFixed(2));

      sum += score_int;

    })
    score = sum / length
  }

  return score;
}

export function getSurveyMonthlyList(surveylist: SurveyModel[]): SurveyMonthlyReport[] {
  let list: SurveyMonthlyReport[] = [];

  getAllMonths.forEach(monthly => {
    let count: number = 0;
    let survey_month: any[] = [];
    let month = moment(monthly).format("MMMM");


    surveylist.forEach(survey => {

      if (survey?.dateCaptured && moment(survey?.dateCaptured).format("MMMM") === month) {
        survey_month.push(survey);
        count += 1;
      }

    })

    list.push({
      month: month,
      total: count,
      survey: survey_month,
      score: isNaN(parseFloat((getOverallScore(survey_month)).toFixed(0))) ?
        0 : parseFloat((getOverallScore(survey_month)).toFixed(0)),
      category: [
        {
          name: getSurveyDepartment.reception.name,
          caption: getSurveyDepartment.reception.caption,
          score: isNaN(parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.reception.name)).toFixed(0))) ?
            0 : parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.reception.name)).toFixed(0))
        }, {
          name: getSurveyDepartment.nursing.name,
          caption: getSurveyDepartment.nursing.caption,
          score: isNaN(parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.nursing.name)).toFixed(0))) ?
            0 : parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.nursing.name)).toFixed(0))
        }, {
          name: getSurveyDepartment.doctor.name,
          caption: getSurveyDepartment.doctor.caption,
          score: isNaN(parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.doctor.name)).toFixed(0))) ?
            0 : parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.doctor.name)).toFixed(0))
        }, {
          name: getSurveyDepartment.cleaning.name,
          caption: getSurveyDepartment.cleaning.caption,
          score: isNaN(parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.cleaning.name)).toFixed(0))) ?
            0 : parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.cleaning.name)).toFixed(0))
        }, {
          name: getSurveyDepartment.catering.name,
          caption: getSurveyDepartment.catering.caption,
          score: isNaN(parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.catering.name)).toFixed(0))) ?
            0 : parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.catering.name)).toFixed(0))
        }, {
          name: getSurveyDepartment.assessment.name,
          caption: getSurveyDepartment.assessment.caption,
          score: isNaN(parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.assessment.name)).toFixed(0))) ?
            0 : parseFloat((getOverallScorePerCategory(survey_month, getSurveyDepartment.assessment.name)).toFixed(0))
        },
      ]
    });

  })

  return list;
}
